module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/TextCase-41305ec9fcdc298fb4f27ca6d907bd54.svg";